// extracted by mini-css-extract-plugin
export var dropdown = "_r6-0";
export var imageWrapper = "_r6-3";
export var itemNameContainer = "_r6-1";
export var productImage = "_r6-2";
export var spinnerWrapper = "_r6-4";